export const getMaxValue = (maxValue: number | string, freeMaxValue: number | string): number | string => {
	if (freeMaxValue === 'inf') return '∞';
	if ((maxValue === 'inf' || typeof maxValue === 'number') && freeMaxValue !== 'inf') return freeMaxValue;
	return maxValue;
};

export const getInfOrValue = (value: number | string | null | undefined) => {
	if (!value || value === 'inf') return '∞';
	return value;
};
